import { Component, OnInit } from '@angular/core';
import { ProductService } from 'src/app/components/shared/services/product.service';
import { SharedMethods } from 'src/app/components/shared/services/sharedMethods-service';

@Component({
  selector: 'app-categories',
  templateUrl: './categories.component.html',
  styleUrls: ['./categories.component.sass']
})
export class CategoriesComponent implements OnInit {

  showSpinner = false;
  categories: any[] = [];
  constructor( public productService: ProductService, public sharedMethods: SharedMethods) { }

  ngOnInit() {


    /* this.categories = this.productService.getCategories(this.productService.cacheProduct);

    if( this.productService.cacheProduct.length === 0) {

      this.showSpinner = true;
      this.productService.getProducts().subscribe(products => {

        this.showSpinner = false;
        this.productService.cacheProduct = products;
        this.categories = this.productService.getCategories(this.productService.cacheProduct);

      },
      err => {
        this.showSpinner = false;
        this.sharedMethods.errorApiShow(err.error.code, err.error.message);
      })

    } else {

      this.categories = this.productService.getCategories(this.productService.cacheProduct);

    } */






    /* if( this.productService.cacheCategories.length === 0 ) {

      this.showSpinner = true;

      this.productService.categories().subscribe(data => {
        this.productService.cacheCategories = data;
        // console.log(data);
        this.showSpinner = false;
      },
      err => {
          this.showSpinner = false;
          this.sharedMethods.errorApiShow(err.error.code, err.error.message);
      });

    } */




  }

}
